<template>
<div class="chapter">
<div class="inner_page">
<h1 class="BookTitle">The Cat Wears a Noose</h1>
<h2 class="BookSubtitle" style="margin-top:60px;">A Rachel Murdock Mystery</h2>
<p class="author" style="margin-top:60px;">Dolores Hitchens writing as D. B. Olsen</p>
<p class="center" style="margin-top:80px;"><img alt="image" src="images/logo3.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?18b435a1